import * as React from 'react';
import { service } from 'services/service';
import Loader from '@/app/forms/Loader';
import { Translation } from "react-i18next";
import Img from '../../components/Img';
class EventbuizzFooter extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      isLoader: false,
      errors: {},
      message: false,
      success: true,
      locale: 'en' 
    };
  }
  componentDidMount() {
    this._isMounted = true;
    this.fetchFooterData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchFooterData = () => {
    this.setState({ isLoader: true });
    service.get(`${process.env.REACT_APP_URL}/api/v2/get-eventbuizz-footer`)
      .then(
        response => {
          if (this._isMounted) {
            if (response) {
				console.log(response.data);
              this.setState({
                data: response.data[0],
                isLoader: false
              });
            } else {
              this.setState({
                message: response.message,
                success: false,
                isLoader: false,
                errors: response.errors
              });
            }
          }
        },
        error => {
          if (this._isMounted) {
            this.setState({
              message: 'Failed to fetch footer data',
              success: false,
              isLoader: false
            });
          }
        }
      );
  }
  renderContent = () => {
    const { data } = this.state;
    if (!data) return null;

    const {
      label_description,
      form_one_label,
      form_one_link,
      form_two_label,
      form_two_link,
    } = data;
    const htmlDescription = label_description
      .replace(
        "%s",
        `<a class="text-decoration-underline" href="${form_one_link}" target="_blank" rel="noopener noreferrer">${form_one_label}</a>`
      )
      .replace(
        "%s",
        `<a class="text-decoration-underline" href="${form_two_link}" target="_blank" rel="noopener noreferrer">${form_two_label}</a>`
      );

    return <div style={{width: '800px'}} dangerouslySetInnerHTML={{ __html: htmlDescription }} />;
  };
  render() {
    const { data, isLoader, message, success } = this.state;
    return (
      <Translation>
        {t => (
          <footer className="footer mt-auto" style={{position: 'relative', bottom: 0, zIndex: 90, background: 'white', marginTop: 'auto'}}>
            {isLoader && <Loader />}
            {message && (
              <div className={`alert ${success ? 'alert-success' : 'alert-danger'}`}>
                {message}
              </div>
            )}
            {data && (
              <div className="ebs-eventbuizz-custom-footer border-top w-100 bg-white" style={{paddingTop: '12px', paddingBottom: '12px'}}>
                <div style={{ maxWidth: '1000px' }} className="container">
                  <div className="row">
                    <div className="col-12 d-sm-flex align-items-center justify-content-center">
                      <div className="d-sm-flex align-items-center pe-sm-1 me-4">
                        {data.label_powered_by && (
                          <span style={{ paddingRight: '10px' }} className="pe-2 mt-1 d-block text-nowrap">
                            {data.label_powered_by}
                          </span>
                        )}
							          <Img alt="EventBuizz" src={require("img/logo-header@2x.png")} width="130px" style={{marginRight: '18px'}} />
                      </div>
                      <div className="ps-sm-4 me-4 ebs-min-border" style={{paddingLeft: '22px', borderLeft: '1px solid #ddd'}}>
                        {this.renderContent()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </footer>
        )}
      </Translation>
    );
  }
}

export default EventbuizzFooter;